import { SourcePreviewFooter } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewFooter.tsx";
import { SourcePreviewHeader } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewHeader.tsx";
import { SourcePreviewTitle } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewTitle.tsx";
import type { SourcePreviewProps } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewProps.ts";
import { useConversationSource } from "#features/conversations/hooks/useConversationSource.ts";
import { Div, Table } from "@hopper-ui/components";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./TablePreview.css";

export const TablePreview = ({ source }: SourcePreviewProps) => {
    const { title, date, description } = useConversationSource(source);

    return (
        <Div className="wai-source-card" overflow="hidden">
            <SourcePreviewHeader source={source} date={date} />
            <SourcePreviewTitle text={title} />
            <Div className="wai-table-preview-table-wrapper" marginTop="inline-sm">
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        table({ ...rest }) {
                            return (
                                <Table width="max-content">
                                    {rest.children}
                                </Table>
                            );
                        }
                    }}
                >
                    {description}
                </ReactMarkdown>
            </Div>
            <SourcePreviewFooter source={source} />
        </Div>
    );
};
